<template>
  <article class='top-bar' :class="{'show-mobile':showMobile}">
      <router-link :to="{name:'Home'}" class="logo"><img src="@/assets/logos/blue-jays-square.svg" alt=""></router-link>
      <Breadcrumbs :class="{'show-mobile':showMobile}"/>
      <button :class="{'show-mobile':showMobile}" v-show="$route.name !== 'Home'" class="toggle-nav" @click="showMobile = !showMobile; $emit('toggleMobile', showMobile)">
        <img class='open' src="@/assets/icons/menu-open.svg" alt="">
        <img class='close' src="@/assets/icons/menu-close.svg" alt="">
      </button>
  </article>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
export default {
  name: "TopBar",
  components: {
    Breadcrumbs,
  },
  data: function () {
    return {
      showMobile:false,      
    };
  }, 
  methods: {
    toggleMobile(value) {
      this.showMobile = value;
    },
  },
  watch: {
    "$route.name"(to, from) {
      this.showMobile = false;
      this.$emit('toggleMobile', this.showMobile)
    },
  },
};
</script>

<style lang="scss" scoped>
  article.top-bar {
    display:flex;
    justify-content: space-between;
    align-items: center;
    position: sticky !important;
    top:0;
    z-index: 2 !important;
    backdrop-filter: blur(2px);    
    transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) !important; 
     background-color:rgba(255,255,255,1);
    @media (min-width:500px) {
       background-color:rgba(255,255,255,0);
    }
   
    &.show-mobile {
      background-color:rgba(255,255,255,0)
    }
    &:after {
      content:"";
      position:absolute;
      bottom:0;
      left:0;
      right:0;
      height:1px;
      background-color: #011529;
      border-bottom:1px solid #003363;
    }
  }
  .logo {
    text-decoration: none;    
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFE 100%);
    padding:9px 18px;
  }
  .toggle-nav {    
    padding:9px 18px;
    user-select: none;
    background: none;
    border: none;
    display: grid;
    place-items: center;
    grid-template-areas: center;
    img {
      grid-area: center;
      opacity: 0;
        transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1); 
        &.close {
          transform:rotateZ(25deg);
        }
    }
    .open {
      opacity: 1;
    }
    &.show-mobile {
      .close {
        opacity: 1;
        transform:rotateZ(0deg);
      }
      .open {
        opacity: 0;
      }
    }
    @media (min-width: 500px) {
      display: none;
    }
  }
</style>